import preact from 'preact'
import Downshift from 'downshift/preact'
import HitContainer from './HitContainer'
import HitContainerWithFederated from './HitContainerWithFederated'
import { SearchBox, doSearch } from './SearchBox'
import localStorageCache from 'utils/localStorageCache'
import { SEARCH_CONVERSION } from 'libs/config'

class AlgoliaSearch extends preact.Component {
  render ({ refine, hits, updateSearch, allSearchResults, indexName, isFederatedSearch, isFederatedSalesforceSearch, isFederatedSkilljarSearch }) {
    return (
      <Downshift
        itemToString={i => (i ? i.title : i)}
        stateReducer={(state, changes) => {
          switch (changes.type) {
            // prevent clicking/selecting items from overwriting inputValue
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.blurInput:
            case Downshift.stateChangeTypes.clickItem:
              return {
                ...changes,
                inputValue: state.inputValue,
                highlightedIndex: null
              }
            default:
              return changes
          }
        }}
        onChange={item => {
          window.aa('click', {
            objectID: item.objectID,
            position: item.position,
            queryID: item.queryID
          })
          localStorageCache.setItem(SEARCH_CONVERSION, {
            objectID: item.objectID,
            queryID: item.queryID
          })

          // user pressed enter to select the item
          if ('KeyboardEvent' in window && window.event instanceof window.KeyboardEvent) {
            if (/^https?/.test(item.topic_url)) {
              window.open(item.topic_url, '_blank')
            } else {
              window.location.href = item.topic_url
            }
          }
        }}
      >
        {({
          getInputProps,
          getItemProps,
          highlightedIndex,
          setHighlightedIndex,
          closeMenu,
          openMenu,
          inputValue,
          reset,
          isOpen
        }) => <div className='algolia-search-container'>
          {
            isOpen ? (
              <div key='backdrop' onClick={closeMenu} className='algolia-search--opacity' />
            ) : null
          }
          <SearchBox
            reset={reset}
            refine={refine}
            updateSearch={updateSearch}
            setHighlightedIndex={setHighlightedIndex}
            inputValue={inputValue}
            getInputProps={getInputProps}
            openMenu={openMenu}
            isOpen={isOpen}
            key='search' />

          {
            inputValue && isOpen
              ? isFederatedSearch || isFederatedSalesforceSearch || isFederatedSkilljarSearch
                ? <HitContainerWithFederated key='hits-container'
                  allSearchResults={allSearchResults}
                  inputValue={inputValue}
                  doSearch={doSearch}
                  hits={hits}
                  highlightedIndex={highlightedIndex}
                  setHighlightedIndex={setHighlightedIndex}
                  getItemProps={getItemProps}
                  indexName={indexName} />
                : <HitContainer key='hits-container'
                  allSearchResults={allSearchResults}
                  inputValue={inputValue}
                  doSearch={doSearch}
                  hits={hits}
                  setHighlightedIndex={setHighlightedIndex}
                  highlightedIndex={highlightedIndex}
                  getItemProps={getItemProps} />
              : null
          }
        </div>
        }
      </Downshift>
    )
  }
}

export default AlgoliaSearch
